import React, { useMemo } from 'react';
import { Box, Text, WarningIcon } from '@common-fe/common-fe';

import { PendingModal } from '@/components/elements';

interface Props {
  email?: string;
  firstName?: string;
  lastName?: string;
  onSetVisible: () => void;
}

const VerificationLinkSentModal: React.FC<Props> = ({ email, firstName, lastName, onSetVisible }) => {
  const fullName = useMemo(() => `${firstName} ${lastName}`, [firstName, lastName]);

  return (
    <PendingModal
      testId="verification-link-sent-modal"
      visible
      onSetVisible={onSetVisible}
      header="Verification link sent"
      icon={<WarningIcon size="48px" />}
      buttonText='Got it!'
    >
      <Box margin={{ top: 'spacing12', bottom: 'spacing24' }} align="center">
        <Text data-testId="verification-link-sent-modal_subtitle">
          A verification link will be sent to <Text weight={700}>{email}</Text>.
        </Text>
        <Text data-testId="verification-link-sent-modal_subtitle">
          {fullName} must verify their email to receive future communications
        </Text>
      </Box>
    </PendingModal>
  );
};

export default VerificationLinkSentModal;
